import { render } from "./DeleteBlogPostDialog.vue?vue&type=template&id=1269bac2"
import script from "./DeleteBlogPostDialog.vue?vue&type=script&lang=js"
export * from "./DeleteBlogPostDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__